import { inject, Service } from "@angular/core";

import { IntpProjectModel, IntpSortedProjectModel, MainResponseModel, TeamMemberType } from "../models";
import { MainService } from ".";

@Service()
export class IntpProjectsApiService {
  private _mainService = inject(MainService);

  public getById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpProjectModel>>({
      method: "GET",
      url: `international-project/getById/${id}`,
    });
  }

  public saveProject(isEdit: boolean, isFinish: boolean, model: IntpProjectModel) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: isEdit
        ? `international-project/update?isFinish=${isFinish}`
        : `international-project/create?isFinish=${isFinish}`,
      data: model,
    });
  }

  public getAllProjects(entityId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpProjectModel[]>>({
      method: "POST",
      url: `international-project/getAllProjects?entityId=${entityId}`,
      data: {},
    });
  }

  public deleteProject(id: number) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url: `international-project/deleteById/${id}`,
      data: {},
    });
  }

  public getProjectsByCountry(countryId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpProjectModel[]>>({
      method: "POST",
      url: `international-project/getProjectsByCountry/${countryId}`,
      data: {},
    });
  }

  public sortProjects(projects: IntpSortedProjectModel[]) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `international-project/sortProjects`,
      data: { projectOrderLists: projects },
    });
  }

  public getDetailedProject(id: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpProjectModel>>({
      method: "GET",
      url: `international-project/values/${id}`,
    });
  }

  public getContactById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<TeamMemberType>>({
      method: "GET",
      url: `international-project/getByContactId/${id}`,
    });
  }
}
